import { render, staticRenderFns } from "./ConnectionChangeLogsDetailsView.vue?vue&type=template&id=165dd0da&scoped=true"
import script from "./ConnectionChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./ConnectionChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./ConnectionChangeLogsDetailsView.vue?vue&type=style&index=0&id=165dd0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165dd0da",
  null
  
)

export default component.exports